/**
 * M4 탈퇴 완료 (시안 06). 되돌아갈 수 없는 화면: 뒤로 가기를 막고, 「처음 화면으로」 → 시작 화면(L0).
 *
 *   골목 사진(채도 0.7) + 먹색 덮개 → 크림 찻잔 마크 44 → 「그동안 고마웠어요」(마루 부리 24/34)
 *   → 「기록은 모두 지웠어요. / 골목 끝 불은 계속 켜 둘게요.」 → 「처음 화면으로」(테두리 52)
 */
import { useNavigate } from 'react-router-dom';
import { BrandMark } from '../../components/Brand.jsx';
import { useBlockBack } from '../../hooks/useBlockBack.js';
import { useDarkChrome } from '../../hooks/useDarkChrome.js';
import { sceneUrl } from '../welcome/SceneCards.jsx';

export function GoodbyePage() {
    const navigate = useNavigate();
    useBlockBack(true);
    useDarkChrome();
    return (
        <div className="relative mx-auto h-dvh max-w-app overflow-hidden bg-text-primary text-bg">
            <img
                src={sceneUrl('alley')}
                alt=""
                aria-hidden="true"
                className="absolute inset-0 size-full object-cover"
                style={{ filter: 'saturate(0.7)' }}
            />
            <span
                aria-hidden="true"
                className="absolute inset-0"
                style={{ background: 'linear-gradient(to bottom, rgba(38,35,31,0.5), rgba(38,35,31,0.92) 70%)' }}
            />
            <main className="absolute inset-x-0 bottom-0 flex flex-col items-center gap-3.5 px-6 pb-[calc(40px+env(safe-area-inset-bottom,0px))] text-center">
                <BrandMark size={44} tone="cream" />
                <h1 className="m-0 font-serif text-[24px] leading-[34px] font-bold">그동안 고마웠어요</h1>
                <p className="m-0 text-[15px] leading-6 text-[#E9E1D4]">
                    기록은 모두 지웠어요.
                    <br />
                    골목 끝 불은 계속 켜 둘게요.
                </p>
                <button
                    type="button"
                    onClick={() => navigate('/start', { replace: true })}
                    className="mt-5 h-[52px] self-stretch rounded-card border border-[rgba(246,241,231,0.6)] text-[16px] font-semibold text-bg"
                >
                    처음 화면으로
                </button>
            </main>
        </div>
    );
}
